module.exports = __webpack_public_path__ + "assets/img/Dover MRT.051637e2.jpg";